import React from "react";
import { Stack } from "@fluentui/react";
import SummaryTable from "./SummaryTable";
import { IReport_Merchant } from "../../../shared/interfaces/IReceipAnalyzerEntities";
import { useAppContext } from "./AppContext";
import { useNavigate } from 'react-router';

const Merchants: React.FC<{ filter?: string }> = ({ filter }) => {
  const navigate = useNavigate();
  const { appData } = useAppContext();

  return (
    <Stack horizontalAlign="center">
    <div className="custom-grid-table-container">
        <SummaryTable
        data={(appData?.data?.reportMerchants ?? [])
          .sort((a, b) => (b.merchant_total_amount ?? 0) - (a.merchant_total_amount ?? 0))
          .map((item, idx) => ({ id: idx, ...item }))}
        columns={[
            {
              key: "name",
              label: "Store",
              width: "50%",
              total: false,
              render: (_: any, item: IReport_Merchant) => (
                <span className='table-cell-content' onClick={() => navigate(`/Merchant?merchantId=${encodeURIComponent(item.merchant_id)}`)} style={{ cursor: 'pointer' }}>{item.name}</span>
              ),
            },
            { key: "city", label: "City", width: "33%", total: false },
            { key: "merchant_total_amount", label: "Total", width: "22%", total: true },
        ]}
        filterKeys={['name' as any, 'city' as any]}
        externalFilter={filter}
        header={true}
        total={true}
        />
    </div>
    </Stack>
  );
};

export default Merchants;
